export default __webpack_public_path__ + "static/media/fitness_mfp2.5033fb74.jpg";